import type { FormComponentRef } from "@inertiajs/core"
import { Form } from "@inertiajs/react"
import { useRef } from "react"

import Enter from "@/assets/svg/enter.svg?react"
import { Textarea } from "@/components/ui/textarea"

interface PromptProps {
  prompt: string
  placeholder: string
  action: string
  onStart?: () => void
}

export const Prompt = ({
  prompt,
  placeholder,
  action,
  ...props
}: PromptProps) => {
  const formRef = useRef<FormComponentRef>(null)

  return (
    <Form
      ref={formRef}
      action={action}
      method="post"
      className="flex w-full flex-col gap-2"
      disableWhileProcessing
      resetOnSuccess
      {...props}
    >
      <div className="order-0 flex w-full flex-none flex-row items-start gap-2 self-stretch rounded-[28px] bg-gray-800 p-3 px-5 text-[15px] leading-6 text-white shadow-sm">
        {prompt}
      </div>
      <Textarea
        name="response"
        required={true}
        className="relative flex min-h-8 w-full resize-none rounded-[28px] bg-white p-4 px-5 text-[15px] leading-6 placeholder:text-[#B9B9B9] focus-visible:border-white focus-visible:ring-[2px] focus-visible:ring-[#E574FF]"
        placeholder={placeholder}
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.metaKey) {
            e.preventDefault()
            formRef.current?.submit()
          }
        }}
      />
      <button className="absolute right-3.5 bottom-3.5">
        <Enter className="size-6 bg-white/50" />
      </button>
    </Form>
  )
}
